const Content = () => (
  <>
    <h2>Common Locksmith Services</h2>
    <p>
      From locking your keys in your car to rekeying the locks on your new home, locksmith services can be a lifesaver. A locksmith can handle almost any issue with your locks, including emergencies
      and planned lock services. They typically work on locks for vehicles, homes and commercial properties. The extent of the work often affects the cost of the services.
    </p>
    <section>
      <h3>What Are Some Common Reasons People Call a Locksmith?</h3>
      <p>
        On average, the cost of locksmith services is around $260, but the price can range from $35 to $500 or more, depending on the situation. The cost often depends on the complexity of the service
        and how long it takes to perform.
      </p>
    </section>
    <section>
      <h3>Rekeying Locks</h3>
      <p>
        {
          "Having your locks rekeyed typically costs $45 to $125 per lock cylinder that you have changed. When a locksmith rekeys your locks, the old keys no longer work, and you'll get a new set of keys that work. It's common to rekey your locks when you move into a new home because the old owners could still have a copy of the key. You might also have the locks changed if you lose your keys or you've handed out copies of keys to other people that you no longer want to have access. For example, if you get divorced and your spouse moves out of the home, rekeying your locks ensures they no longer have access to the home. The same could be necessary if you have a roommate who moves out of your home."
        }
      </p>
    </section>
    <section>
      <h3>Lockouts</h3>
      <p>
        Getting locked out of your car or home causes major headaches until you can regain entry. A locksmith can help you with a car lockout for $45 to $60 to help you unlock the vehicle. To drill
        and replace the car lock, it typically costs $40 to $150. For your home, you can expect to pay $35 to $165 to have a locksmith unlock your home or replace the lock. Emergency lockout services
        outside of business hours typically cost up to $200 extra, depending on the circumstances.
      </p>
    </section>
    <section>
      <h3>Lock Installation</h3>
      <p>
        {
          "Upgrading to more advanced locks can make your home more secure and offer convenient keyless ways to get in. Lock installation can be a DIY project, but having a locksmith handle the work ensures the locking system is installed correctly. You can expect to pay between $100 and $500 to have a keyless lock system installed. That cost is on top of the price of the lock. This might include locking systems that use codes, biometrics or Bluetooth to unlock your doors. More advanced, high-tech options typically cost more to have installed because they're more complex. While pricey, these systems can help you avoid calls to a locksmith in the future because they don't require a key for entry."
        }
      </p>
    </section>
    <section>
      <h3>Key Replacement or Copies</h3>
      <p>
        If you need new copies of your keys, a locksmith can help you with that as well. Copies of regular keys are usually inexpensive, at around $1 to $4 per key. The price is higher for specialty
        or high-tech keys. You might have the locksmith make extra copies of the keys when you have your home rekeyed or have a new lock installed.
      </p>
    </section>
    <section>
      <h3>Broken Locks</h3>
      <p>
        {
          "If your lock stops functioning properly, a locksmith can determine if it can be fixed or needs to be replaced. Sometimes, the lock just needs a little lubrication or a few replacement parts. In that case, you'll likely pay the minimum service fee or an hourly rate. If someone tried to break into your home or some of the lock parts are bent, you might need a full lock replacement. Installation can cost you between $100 and $500, but you might have a smaller bill if you're having a basic lock installed."
        }
      </p>
    </section>
    <section>
      <h3>Cost Factors for Locksmith Services</h3>
      <p>
        {
          "Several factors can go into what you'll pay for locksmith services. A locksmith might charge a minimum service fee for minor, inexpensive lock repairs to make it worth their time. Many locksmiths also charge trip or callout fees to travel to your location for lock services. Some companies charge mileage, so you'll pay more if the company you hire is a long distance from your location. Finding a nearby locksmith can save you on the fees. You'll also likely pay more for emergency locksmith services or any services performed outside normal business hours or on a holiday. For something like being locked out of your car or home, you usually can't wait until business hours for the service, so it can be difficult to avoid the extra emergency service fees."
        }
      </p>
    </section>
  </>
);

export default Content;
